import { Box, Link, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { useAuthContext } from '../../../auth/useAuthContext';
import { CustomAvatar } from '../../../components/custom-avatar';
import { PATH_USER } from '../../../routes/paths';

export default function NavAccount() {
  const { user, role } = useAuthContext();

  return (
    <Link component={RouterLink} to={PATH_USER.account} underline="none" color="inherit">
      <StyledRoot>
        <CustomAvatar src={user?.photoURL || undefined} alt={user?.displayName} name={user?.displayName} />

        <Box sx={{ ml: 2, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.displayName}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
            {role === 'user' ? 'Guest' : role}
          </Typography>
        </Box>
      </StyledRoot>
    </Link>
  );
}

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));
